import { Button, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import * as React from 'react';
import CustomTextField from '../CustomFields/CustomTextField';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import { validationFormDos } from './ValidationForm';

export default function FormInicioCotizacion(props) {
  const navigate = useNavigate();
  const handleListo = (values, setSubmitting) => {
    const datosCotizacion = {
      correo: values.correo,
      num: values.num,
    }
    window.sessionStorage.setItem("FormDosInterGMM", JSON.stringify(datosCotizacion));
    setSubmitting(false);
    navigate('/Bienvenida');
  };

  return (
    <Formik
      validateOnChange={true}
      initialValues={{
        num: '',
        correo: '',
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        handleListo(values, setSubmitting);
      }}
      validationSchema={validationFormDos}>
      {({ values, submitForm, setFieldValue, handleChange, errors, isSubmitting, setFieldError, touched, setFieldTouched, }) => (

        <Form>
          <Grid container direction="column" justifyContent="center" alignItems="center" spacing={4}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
              <div className="form-titulo">Siguenos con tu proceso de cotizaci&oacute;n</div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
              <div className="label-input mX-10">¿Cu&aacute;l es tu n&uacute;mero de cotizaci&oacute;n?</div>
              <CustomTextField id="num" name="num" type="text" placeholder="No." className="grid-item-input" />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
              <div className="label-input mX-10">Y ¿tu correo electr&oacute;nico?</div>
              <CustomTextField id="correo" name="correo" type="text" placeholder="ejemplo@gmail.com" className="grid-item-input" />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100 pt-0px">
              <Grid container direction="column" alignItems="flex-end" justifyContent="flex-end" className="w-100">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                  <Button onClick={(event) => props.handleTipoForm(false)} className="texto-numero-cotizacion">
                    ¿No tienes un n&uacute;mero de cotizaci&oacute;n?
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
              <Button variant="contained" disableElevation endIcon={<ArrowForwardIcon />} className="button-continuar w-100"
                 onClick={submitForm} disabled={isSubmitting}>
                ¡Estoy list@!
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );

}